/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type GetPlanResponseDto = {
    type: GetPlanResponseDto.type;
};

export namespace GetPlanResponseDto {

    export enum type {
        DATA_CATALOG = 'DATA_CATALOG',
        INTEGRATION = 'INTEGRATION',
        MONITORING = 'MONITORING',
        SETTINGS = 'SETTINGS',
        TENANT = 'TENANT',
    }


}
